module.exports = __webpack_public_path__ + "media/images/payment_methods/paysafecard-9c58ede912515b1e76287aef18aef454.svg";